@import '../../utils/button-base.css';
@import '../../utils/table-caption-control.css';

:host {
  --ds-button-unfilled-fg: var(--color-foreground-secondary);
  --ds-button-unfilled-fg-active: var(--color-foreground-primary);
  --ds-button-unfilled-dot-ring: var(--color-background-secondary);
  --ds-button-unfilled-border: var(--color-border-secondary);
}

.button-unfilled {
  background: transparent;
  color: var(--ds-button-unfilled-fg);
  /* Hover/press/selected fill: `.ds-interaction-fill` (+ `--selected` / `--on-*`).
     Active foreground changes remain independent from popup-open pressed paint. */
}

.button-unfilled--active {
  color: var(--ds-button-unfilled-fg-active);
}

/*
 * An open popup is a transient pressed state, not a selected state. Keep the
 * pressed wash visible for the popup's complete rendered lifecycle without
 * promoting the resting foreground or selected fill.
 */
/* Inset stroke via interaction-fill ::after (above selected / hover washes). */
.button-unfilled--bordered {
  --ds-interaction-border-color: var(--ds-button-unfilled-border);
}

/* Inactive: `.ds-control-inactive` (50% opacity). */

/* Foreground / chrome tokens per surface — interaction tokens come from util `--on-*`. */
.button-unfilled--background-medium {
  --ds-button-unfilled-fg: var(--color-foreground-on-medium-background-secondary);
  --ds-button-unfilled-fg-active: var(--color-foreground-on-medium-background-primary);
  --ds-button-unfilled-dot-ring: var(--color-background-medium-neutral);
  --ds-button-unfilled-border: var(--color-border-on-medium-background-secondary);
}

.button-unfilled--background-bold {
  --ds-button-unfilled-fg: var(--color-foreground-on-bold-background-secondary);
  --ds-button-unfilled-fg-active: var(--color-foreground-on-bold-background-primary);
  --ds-button-unfilled-dot-ring: var(--color-background-bold-neutral);
  --ds-button-unfilled-border: var(--color-border-on-bold-background-secondary);
}

.button-unfilled--background-strong {
  --ds-button-unfilled-fg: var(--color-foreground-on-strong-background-secondary);
  --ds-button-unfilled-fg-active: var(--color-foreground-on-strong-background-primary);
  --ds-button-unfilled-dot-ring: var(--color-background-strong-neutral);
  --ds-button-unfilled-border: var(--color-border-on-strong-background-secondary);
}

.button-unfilled--background-translucent {
  --ds-button-unfilled-fg: var(--color-translucent-foreground-secondary);
  --ds-button-unfilled-fg-active: var(--color-translucent-foreground-primary);
  --ds-button-unfilled-dot-ring: var(--color-translucent-translucent);
  --ds-button-unfilled-border: var(--color-translucent-border-secondary);
}

.button-unfilled--background-inverted {
  --ds-button-unfilled-fg: var(--color-inverted-foreground-secondary);
  --ds-button-unfilled-fg-active: var(--color-inverted-foreground-primary);
  --ds-button-unfilled-dot-ring: var(--color-inverted-background);
  --ds-button-unfilled-border: var(--color-inverted-border-secondary);
}

.button-unfilled--background-media {
  --ds-button-unfilled-fg: var(--color-media-foreground-secondary);
  --ds-button-unfilled-fg-active: var(--color-media-foreground-primary);
  --ds-button-unfilled-dot-ring: var(--color-media-background);
  --ds-button-unfilled-border: var(--color-media-border-secondary);
}

.button-unfilled--on-always-dark {
  --ds-button-unfilled-fg: var(--color-always-dark-foreground-secondary);
  --ds-button-unfilled-fg-active: var(--color-always-dark-foreground-primary);
  --ds-button-unfilled-dot-ring: var(--color-always-dark-background);
  --ds-button-unfilled-border: var(--color-always-dark-border-secondary);
}

/*
 * After surface ring defaults: selected fill remaps the knock-out to the active
 * wash so the badge halo matches the selected background.
 */
.button-unfilled.ds-interaction-fill--selected {
  --ds-button-unfilled-dot-ring: var(--ds-interaction-active);
}
